import { useEffect, useState } from 'react'

import { EventTypes, IDataLayerFooterParams, IDataLayer } from './typesUseDataLayer'

/**
 *  Data Layer Event
 *  Saiba Mais: https://confluence.bancointer.com.br/pages/viewpage.action?pageId=188390035#Novopadr%C3%A3odetagueamento-PARADEVS
 */

const useDataLayerFooter = (event?: EventTypes) => {
  const [dataLayerEvent, setDataLayerEvent] = useState<EventTypes>('ga_event_footer')

  useEffect(() => {
    event && setDataLayerEvent(event)
  }, [dataLayerEvent])

  const returnDataLayer = (data: IDataLayerFooterParams) => {
    const { section, element_action, element_name, redirect_url, c_page }: IDataLayerFooterParams =
      data

    const dataLayer: IDataLayer = {
      event: dataLayerEvent,
      params: {
        section: section || 'null',
        element_action,
        element_name,
        redirect_url: redirect_url || 'null',
        c_page,
      },
    }

    return dataLayer
  }

  const sendDatalayerFooterEvent = (dataLayer: IDataLayerFooterParams) => {
    const dataLayerPayload = returnDataLayer(dataLayer)

    if (window && window.dataLayer) {
      window.dataLayer.push(dataLayerPayload)
    }

    return window.dataLayer
  }

  return [sendDatalayerFooterEvent]
}

export default useDataLayerFooter
